import React from 'react';

const MinusIcon = (props) => (
  <svg width='32' height='32' viewBox='0 0 32 32' {...props}>
    <g fill='none' fillRule='evenodd'>
      <g fill='currentColor'>
        <path
          d='M24 16c0 .552-.448 1-1 1H9c-.552 0-1-.448-1-1s.448-1 1-1h14c.552 0 1 .448 1 1z'
          transform='translate(-389.000000, -16.000000) translate(389.000000, 16.000000)'
        />
      </g>
    </g>
  </svg>
);

export default MinusIcon;
